import { useQuery } from "@tanstack/react-query";

import api from "@/common/utils/api";

export const adminUsersQueryKey = (search: string) =>
  ["admin", "users", search] as const;

export function useAdminUsersSearch(search: string) {
  return useQuery({
    queryKey: adminUsersQueryKey(search),
    queryFn: () =>
      api
        .get<"/admin/users">(`/admin/users`, { params: { search } })
        .then((res) => res.data),
  });
}
